var generateStyle = function generateStyle(componentTheme) {
  return {
    radioWrapper: {
      paddingTop: componentTheme.radioWrapperPadding
    },
    noResponseWrapper: {
      marginTop: componentTheme.noResponseWrapperMargin
    },
    responseWrapper: {
      width: '100%',
      marginTop: componentTheme.responseMarginTop
    }
  };
};
export default generateStyle;